import { GET_NOM_SYNC, NOM_ERROR } from 'src/actions/types'

const initialState = {
  nominas: [],
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_NOM_SYNC:
      return {
        ...state,
        nominas: payload,
        loading: false,
        error: {},
      }
    case NOM_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
